<template>
  <div class="helps-content">
    <!-- <p class="title">{{ resData[0].title }}</p> -->
    <div class="article">
      <div class="article-list" v-for="(item, index) in resData" :key="index">
        <h2 class="title">{{ item.title ? item.title : '暂无内容'}}</h2>
        <ul>
          <li v-for="(subItem, subIndex) in item.actitle_list" :key="subIndex" @click="handleClick(item.title, subItem.title, subItem.id)">
            {{ subItem.title}}
          </li>
        </ul>
        <div class="hasmore" v-if="item.actitle_list && item.actitle_list.length > list_size" @click="hasMore(item.title)">还有 <span>{{ item.acticle_count - list_size }}</span> 篇文档 ></div>
      </div>
    </div>
  </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js";
export default {
  name: "HelpsContent",
  mounted() {},
  data() {
    return {
      differentiate: 0,
      resData: [],
      list_size: 6,
      isShow: false,
      init: {}
    };
  },
  methods: {
    handleClick(title, subTitle, subId) {
      let passback = {
        subTitle: subTitle,
        title: title,
        id: this.$route.query.id,
        mainTitle: this.$route.query.title
      };
      // 将标题数据保存在本地
      sessionStorage.passback = JSON.stringify(passback);
      this.$emit("customEvent", passback);

      this.$router.push({
        path: "/HelpsArticle",
        query: {
          title: subTitle,
          subId: subId
        }
      });
    },
    hasMore(title, subTitle) {
      let navTitle = {
        title: title,
        id: this.$route.query.id,
        mainTitle: this.$route.query.title
      };

      //将标题数据保存在本地
      sessionStorage.passback = JSON.stringify(navTitle);
      this.$emit("customEvent", navTitle);

      this.$router.push({
        path: "/HasMoreArticle",
        query: {
          id: this.$route.query.id,
          title: this.$route.query.title
        }
      });
    }


  },
  created() {
    // 接收路由参数
    // console.log(this.$route.query);
    this.differentiate = this.$route.query.id;
    this.$Loading.start()
    doPost(
      {
        action: "get_secondCategory",
        firstCategory_id: this.$route.query.id,
        firstCategory_title: this.$route.query.title
      },
      data => {
        this.$Loading.finish()
        if (data.data.length != 0) {
          data = data.data.map(item => {
            return item;
          });
        }
        this.resData = data;
      }
    );
  },
  watch: {
    // 监听,当路由发生变化的时候执行
    $route(to, from) {
      if (!to.query.id) return;
      this.differentiate = to.query.id;
       this.$Loading.start()
      doPost(
        {
          action: "get_secondCategory",
          firstCategory_id: to.query.id,
          firstCategory_title: to.query.title
        },
        data => {
          if (data.data.length != 0) {
            data = data.data.map(item => {
              return item;
            });
          }
          this.resData = data;
           this.$Loading.finish()
        }
      );
    }
  }
};
</script>

<style lang="stylus" scoped>
.helps-content {
  display: inline-block;
  margin-left: 36px;
  width: 80%;

  .article {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .article-list {
    display: inline-block;
    width: 50%;
    margin-bottom: 0.8rem;
  }

  .title {
    padding: 10px 0;
    font-size: 20px;
    margin-bottom: 13px;
    cursor pointer
  }

  li {
    margin-bottom: 20px;
    cursor: pointer;

    &:hover {
      color: #2bd3a0;
    }
  }

  .hasmore {
    font-size: 12px;
    color: #2bd3a0;
    margin-top: 15px;
    cursor: pointer;
  }

  .clearfix:after, .clearfix:before {
    content: ' ';
    display: table;
  }

  .clearfix:after {
    clear: both;
  }
}

@media screen and (max-width: 1114px) {
  .helps-content .article-list {
    width: 100%;
  }
}

@media screen and (max-width: 758px) {
  .helps-content {
    width: 100%;
    margin: 0;
  }
}
@media screen and (max-width: 456px)
  .helps-content .article-list
    width 100%
</style>




// WEBPACK FOOTER //
// src/pages/Tutorial/components/HelpsContent.vue